<div class="container">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>Work Orders List</h2>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex gap-2 mb-3">
      <div class="form-floating">
        <select id="financialYearSelect" class="form-select w-auto" [(ngModel)]="selectedFinancialYear" (change)="applyFilters()">
          <option value="all">ALL</option>
          <option *ngFor="let year of financialYears" [value]="year">{{ year }}</option>
        </select>
        <label for="financialYearSelect">Financial Year</label>
      </div>
      <div class="form-floating">
        <select id="stageSelect" class="form-select" [(ngModel)]="selectedStage" (change)="filterByStage()">
          <option value="" disabled selected hidden></option>
          <option *ngFor="let stage of stages" [value]="stage">{{ stage.toUpperCase() }}</option>
        </select>
        <label for="stageSelect">State</label>
      </div>
    </div>
    <button (click)="exportToExcel()" class="btn btn-success btn-sm">
      <i class="fa fa-file-excel"></i>Export to Excel</button>
  </div>
  <div class="custom-table-wrapper">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>WO #</th>
          <th>PO #</th>
          <th>Date</th>
          <th>Client</th>
          <th>Actions</th>
        </tr>
        <!-- Filtering Row -->
        <tr>
          <th><input type="text" class="form-control" placeholder="Search WO #" [(ngModel)]="filter.woId"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search PO #" [(ngModel)]="filter.poId"
          (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Work Order Date" [(ngModel)]="filter.date"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Company" [(ngModel)]="filter.workOrderCompany"
              (input)="applyFilters()" /></th>

          <th>
            <button (click)="resetFilters()" class="btn btn-primary btn-sm">
              <i class="fa fa-x" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let po of filteredWorkOrderData" [ngClass]="{ 'table-danger': isDeleted(po) }">

          <td>{{ po.workOrderFields.workOrderId }}</td>
          <td>{{ po.workOrderFields.purchaseOrderNumber || '-' }}</td>
          <td>{{ po.workOrderFields.workOrderDate | date:'dd/MM/yyyy' }}</td>
          <td>
            {{ workOrderCommonServices?.getClientName(po.workOrderFields.workOrderCompanyId)?.companyName || '-' }}
          </td>

          <td>
            <div *ngIf="isDeleted(po)">
              <strong>Deleted By:</strong> {{ po.workOrderFields.modifiedBy || '-' }}<br>
              <strong>Deleted On:</strong> {{ po.workOrderFields.modifiedOn | date:'dd/MM/yyyy' }}
            </div>
            <button *ngIf="po.workOrderFields.isDeleted && hasPermission('WorkOrdersIsAdminPermission')"
              (click)="restoreWorkOrder(po)" class="btn btn-warning btn-sm" container="body" triggers="hover"
              tooltip="Restore this work order">
              <i class="fa fa-undo" aria-hidden="true"></i> Restore
            </button>

            <ng-container *ngIf="!isDeleted(po)">
              <button (click)="editWorkOrder(po)" class="btn btn-primary btn-sm">
                <i class="fa fa-edit"></i>
              </button>
              <button (click)="viewWorkOrder(po)" class="btn btn-primary btn-sm">
                <i class="fa fa-eye"></i>
              </button>
              <button (click)="deleteWorkOrder(po)" class="btn btn-danger btn-sm">
                <i class="fa fa-trash"></i>
              </button>
            </ng-container>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>
